<faxe-page-layout>
  @if (true) {
  <mat-card appearance="outlined" class="faxe-card">
    <faxe-page-title></faxe-page-title>
    <div class="raceClass">
      <faxe-select-option-chip
        formCtrlName="raceClass"
        [parentFormGroup]="formGroup"
        (valueChange)="onSelectedClassChange($event)"
        label="Klass"
        [dataSource]="raceClassDataItem"
        [selectedByKey]="priviousSelectedClasses"
      >
      </faxe-select-option-chip>
    </div>
    @if (tableData?.rows?.length) {
    <faxe-table
      [data]="tableData"
      (inlineEditAction)="inlineEditAction($event)"
      (iconClicked)="onIconClicked($event)"
    >
    </faxe-table>
    }
  </mat-card>
  }
</faxe-page-layout>
